import { render, staticRenderFns } from "./MealComponent.vue?vue&type=template&id=189b4f22&scoped=true"
import script from "./MealComponent.vue?vue&type=script&lang=js"
export * from "./MealComponent.vue?vue&type=script&lang=js"
import style0 from "./MealComponent.vue?vue&type=style&index=0&id=189b4f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b4f22",
  null
  
)

export default component.exports